module.exports = __webpack_public_path__ + "iot.png";